
import service from '@/store/services/settings/skills-service';

const state = {
    list: {},
    skill: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, skill) => {
        state.skill = skill;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(skill => {
                commit('SET_RESOURCE', skill);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(skill => {
                commit('SET_RESOURCE', skill);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((skill) => {
                commit('SET_RESOURCE', skill);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((skill) => {
                commit('SET_RESOURCE', skill);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    skill: state => state.skill,
    dropdown: (state) => {
        return state.list.map(skill => ({
            id: skill.id,
            name:skill.name,
            alias:skill.alias,
            report_name:skill.report_name,
        }));
    }
};

const skills = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default skills;
